module.exports = __webpack_public_path__ + "img/Alipay.93f85f6f.png";